<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs" />
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Personal Settings">
              <div class="d-flex">
                <div class="w-100">
                  <b-card-title>Personal Settings</b-card-title>
                </div>
              </div> 
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <td class="text-right">{{user.name}}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td class="text-right">{{user.email}}</td>
                  </tr>
                </tbody>
              </table>
              <b-button to="/settings/account">Edit Personal Settings</b-button>
              <b-button to="/settings/password">Change Password</b-button>
            </b-tab>
            <b-tab title="Teams & Notifications">
              <div class="d-flex">
                <div class="w-100">
                  <b-card-title>Teams & Notifications</b-card-title>
                </div>
              </div> 
              <table class="table table-hover table-striped table-sm mb-0" v-if="user.team_users.length > 0">
                <thead>
                  <tr>
                    <th>Team</th>
                    <th>My Role</th>
                    <th>My Permissions</th>
                    <th>Email Notifications</th>
                    <!-- <th></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(teamUser, teamUserIndex) in user.team_users" :key="teamUserIndex" style="cursor:pointer" @click="selectTeamUser(teamUser)">
                    <td>
                      <strong>{{teamUser.team.name}}</strong>
                    </td>
                    <td>
                      <span v-if="teamUser.is_admin && teamUser.is_member">Admin & Team Member</span>
                      <span v-else-if="teamUser.is_admin">Admin</span>
                      <span v-else-if="teamUser.is_member">Team Member</span>
                    <td>
                      <permission-list :availablePermissions="availablePermissions(teamUser)" :permissions="teamUser.permissions" :columns="1"></permission-list>
                    </td>
                    <td>
                      <notification-list :notifications="teamUser.notifications" :columns="1"></notification-list>
                    </td>
<!--                     <td style="vertical-align: middle">
                      <b-button-group class="float-right m-1" v-if="canEditNotifications(teamUser)">
                        <b-button @click.stop="showEditModal(teamUserIndex)" variant="secondary">
                          <icon name="edit" size="14"></icon>
                          Edit
                        </b-button>
                      </b-button-group>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-modal v-for="(teamUser, teamUserIndex) in user.team_users" :key="teamUserIndex" :id="`teamUserModal${teamUserIndex}`"
             size="lg" :title="teamUser.team.name" no-close-on-backdrop no-close-on-esc hide-header-close>

      <b-form @submit="saveEditModal(teamUserIndex)">
        <b-form-group label-cols="4" label="Email Notifications">
          <b-form-checkbox-group v-model="teamUser.notifications" stacked>
            <div v-for="(notification, notificationIndex) in availableNotifications" :key="notificationIndex">
              <b-form-checkbox :value="notification.id">
                {{notification.name}}
              </b-form-checkbox>
              <b-form-text tag="p">{{notification.description}}</b-form-text>
            </div>
          </b-form-checkbox-group>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer>
        <b-button @click="cancelEditModal(teamUserIndex)" variant="secondary">Cancel</b-button>
        <b-button @click="saveEditModal(teamUserIndex)" variant="primary">Save Changes</b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import Permissions from '@/lib/permissions'
import Icon from '@/components/Icon'
import PermissionList from '@/components/manage/PermissionList'
import NotificationList from '@/components/manage/NotificationList'

export default {
  name: 'Settings',
  components: { Icon, PermissionList, NotificationList },
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'Settings', to: '/settings', active: true}],
      user: this.$store.state.user
    }
  },
  methods: {
    allTeamPermissions () {
      var permissions = []
      _.each(Permissions.teamAdminPermissions, (p) => permissions.push(p))
      _.each(Permissions.teamMemberPermissions, (p) => {
        if (_.indexOf(permissions, (perm) => perm.id === p.id) === -1) {
          permissions.push(p)
        }
      })
      return permissions
    },
    availablePermissions (teamUser) {
      if (teamUser.is_admin && teamUser.is_member) {
        return this.allTeamPermissions()
      } else if (teamUser.is_admin) {
        return Permissions.teamAdminPermissions
      } else {
        return Permissions.teamMemberPermissions
      }
    },
    fetchData () {

    },
    availableNotifications () {
      return Permissions.emailNotifications
    }
    // canEditNotifications (teamUser) {
    //   return teamUser.permissions.indexOf('manage_notifications') !== -1
    // },
    // showEditModal (modalIndex) {
    //   this.$bvModal.show(`teamUserModal${modalIndex}`)
    // },
    // cancelEditModal (modalIndex) {
    //   this.$bvModal.hide(`teamUserModal${modalIndex}`)
    //   this.company = null
    //   this.fetchData()
    // },
    // saveEditModal (modalIndex) {
    //   const teamUser = this.teamUsers[modalIndex]
    //   const params = {
    //     admin: this.admin,
    //     is_member: true,
    //     permissions: teamUser.permissions,
    //     notifications: teamUser.notifications
    //   }
    //   API.put(`/companies/${this.companyId}/teams/${this.teamId}/team_users/${teamUser.id}`, params, this.$store.getters.authHeaders).then((result) => {
    //     this.fetchData()
    //     this.$bvModal.hide(`teamUserModal${modalIndex}`)
    //   })
    // },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/Settings.vue